import { getLocale } from "../runtime";

const sv_trackordererrorloading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kunde inte ladda spårningsinformation`
};

const trackordererrorloading = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_trackordererrorloading(inputs)
	return "trackOrderErrorLoading";
};

export { trackordererrorloading as "trackOrderErrorLoading" };